/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var SupportGray = function SupportGray(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Support icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['support--gray--paint0_linear', 'support--gray--paint1_linear', 'support--gray--paint2_linear', 'support--gray--paint3_linear', 'support--gray--paint4_linear', 'support--gray--paint5_linear', 'support--gray--paint6_linear', 'support--gray--paint7_linear', 'support--gray--paint8_linear', 'support--gray--paint9_linear', 'support--gray--paint10_linear', 'support--gray--paint11_linear', 'support--gray--filter0_f'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    viewBox: "0 0 140 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v178H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 0H0v178h140V0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: ".47"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: ".47",
    d: "M69.8 92l70 40.3L139.6.5H0v132L69.8 92z",
    fill: "url(#".concat(gradientIds['support--gray--paint0_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".47",
    d: "M69.8 92l70 40.3L139.6.5H0v132L69.8 92z",
    fill: "url(#".concat(gradientIds['support--gray--paint1_linear'], ")")
  })), /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M0 132.5L69.8 92l70.2 40.4-69.7 40.5L0 132.5z",
    fill: "url(#".concat(gradientIds['support--gray--paint2_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M140 132.5v5.1L70.2 178v-5.1l69.8-40.4z",
    fill: "url(#".concat(gradientIds['support--gray--paint3_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M70.3 172.9v5.1L0 137.6v-5.1l70.3 40.4z",
    fill: "url(#".concat(gradientIds['support--gray--paint4_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3 122.4l-1-.6v-25l1 .6v25z",
    fill: "url(#".concat(gradientIds['support--gray--paint5_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 78.9l.1 25.1-31.6 18.5v-25l31.5-18.6z",
    fill: "url(#".concat(gradientIds['support--gray--paint6_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".6",
    d: "M33.2 97.4l-1-.6 31.5-18.5 1 .6-31.5 18.5z",
    fill: "url(#".concat(gradientIds['support--gray--paint7_linear'], ")")
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(gradientIds['support--gray--filter0_f'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1 132l33.7-19.4 20.1 11.6-33.7 19.4L44.1 132z",
    fill: "#555",
    fillOpacity: "0.15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.7 109.4l-1-.6 31.5-18.5 1 .6-31.5 18.5z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8 134.4l-1-.6-.1-25 1 .6.1 25z",
    fill: "url(#".concat(gradientIds['support--gray--paint8_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2 90.9l.1 25.1-31.5 18.5-.1-25 31.5-18.6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8 137.2l-1-.6-.1-25 1 .6.1 25z",
    fill: "url(#".concat(gradientIds['support--gray--paint9_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7 112.2l-1-.6 31.5-18.5 1.1.6-31.6 18.5z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M86.3 93.6v25.1l-31.5 18.5-.1-25 31.6-18.6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9 140.1l-1-.6-.1-25 1 .6.1 25z",
    fill: "url(#".concat(gradientIds['support--gray--paint10_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8 115.1l-1-.6L90.3 96l1.1.6-31.6 18.5z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M91.4 96.5v25.1l-31.5 18.5-.1-25 31.6-18.6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 117.8l-1.1-.6 31.6-18.5 1 .6-31.5 18.5z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 142.8l-1-.6-.1-25 1.1.6v25z",
    fill: "url(#".concat(gradientIds['support--gray--paint11_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M96.4 99.3v25.1l-31.5 18.5v-25l31.5-18.6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint0_linear'],
    x1: "69.9",
    y1: "21.574",
    x2: "69.9",
    y2: "175.037",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".996",
    stopColor: "#A3A3A3",
    stopOpacity: ".5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint1_linear'],
    x1: "69.9",
    y1: ".5",
    x2: "69.9",
    y2: "132.5",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint2_linear'],
    x1: "119.663",
    y1: "165.349",
    x2: "18.273",
    y2: "98.184",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#B0B0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint3_linear'],
    x1: "70.2",
    y1: "155.25",
    x2: "140",
    y2: "155.25",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint4_linear'],
    x1: "0",
    y1: "155.25",
    x2: "70.3",
    y2: "155.25",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#BBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint5_linear'],
    x1: "32.95",
    y1: "67.743",
    x2: "32.881",
    y2: "87.027",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint6_linear'],
    x1: "38.354",
    y1: "131.93",
    x2: "57.642",
    y2: "75.965",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint7_linear'],
    x1: "22.241",
    y1: "65.7",
    x2: "51",
    y2: "90.005",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#9B9B9B",
    stopOpacity: ".4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint8_linear'],
    x1: "49.25",
    y1: "134.4",
    x2: "49.25",
    y2: "108.757",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint9_linear'],
    x1: "54.25",
    y1: "137.2",
    x2: "54.25",
    y2: "111.557",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint10_linear'],
    x1: "59.35",
    y1: "140.06",
    x2: "59.35",
    y2: "114.417",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--gray--paint11_linear'],
    x1: "64.35",
    y1: "142.838",
    x2: "64.35",
    y2: "117.195",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: gradientIds['support--gray--filter0_f'],
    x: "40.1",
    y: "108.6",
    width: "61.8",
    height: "39",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2",
    result: "effect1_foregroundBlur"
  }))));
};
SupportGray.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var SupportGray$1 = SupportGray;

export { SupportGray$1 as default };
